import { render, staticRenderFns } from "./BirthDate.vue?vue&type=template&id=c390d410&lang=pug"
import script from "./BirthDate.vue?vue&type=script&lang=js"
export * from "./BirthDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports